// extracted by mini-css-extract-plugin
export var content = "LinkColumn-module--content--39Z-s";
export var external = "LinkColumn-module--external--4jrmx";
export var link = "LinkColumn-module--link--H6ahm";
export var title = "LinkColumn-module--title--MtEhv";
export var wrapper = "LinkColumn-module--wrapper--cgWMF";